<template>
	<div class="source-wrap">
		<div class="h2-title-wrap" v-if="item.titleFlag==1">
			<h2 class="h2-title">
				<span>相关资源</span>
			</h2>
		</div>
		<div class="source">
			<div class="source-l">
				<ul class="tablist">
					<li :class="[sourceIndex==index?'active':'']" @click="changeSource(item.id, item2.id, index)"
						v-for="(item2, index) in item.list">{{item2.categoryName}}</li>
				</ul>
			</div>
			<div class="source-r">
				<ul class="type-cnt">
					<li v-for="item3 in sourceList">
						<div class="type-list" @click="toSourceDetail(item3.linkRoute)">
							<p>{{item3.title}}</p>

							<a class="link" @click="toDown(item3.webUrl)" target="_blank">
								<span class="text">点击下载</span>
								<span class="el-icon-right"></span>
							</a>

						</div>
					</li>
					<li></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import {
		post,
		config,
		ajaxParam
	} from '@/units/request.js'
	export default {
		name: 'ResourceTab',
		props: {
			item: {
				type: Object,
				value: {}
			}
		},
		data(){
			return{
				sourceIndex: 0,
				sourceList: [],
				userId: ''
			}
		},
		created(){
			this.userId = localStorage.getItem('userId') || ''
			if(this.item.list.length>0){
				this.getSourceList(this.item.id,this.item.list[0].id)
			}
		},
		methods: {
			//切换相关资源
			changeSource(detailId, sourceId, index) {
				this.sourceIndex = index
				this.getSourceList(detailId, sourceId)
			},
			//获取相关资源分类数据
			async getSourceList(detailId, sourceId) {
				let param = {
					detailId: detailId,
					categoryIdOne: sourceId
				}
				ajaxParam(param)
				const res = await post('v1/product/resourceList', qs.stringify(param))
				if (res.data.code == 200) {
					this.sourceList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			toSourceDetail(linkRoute) {
				this.$router.push({
					path: linkRoute
				})
			},
			toDown(picUrl) {
				// if (!this.userId) {
				// 	this.$router.push({
				// 		path: '/login'
				// 	})
				// 	return
				// }
				window.open(picUrl)
			}
		}
	}
</script>

<style scoped lang="less">
	.source-wrap {
		background: #fff;
		//padding: 110px 0 90px;
		padding: 50px 20px 0;
		box-sizing: border-box;
		.source {
			display: flex;
			justify-content: space-between;
			width: 1140px;
			margin: 40px auto 0;

			.source-l {
				width: 16%;

				ul li {
					position: relative;
					border-left: 2px solid #efefef;
					padding-bottom: 50px;
					padding-left: 20px;
					color: #999;
					cursor: pointer;
					font-size: 16px;
					line-height: 1.95;
				}

				li:before {
					content: '';
					width: 2px;
					height: 20px;
					position: absolute;
					background: #efefef;
					left: -2px;
					top: 8px;
				}

				li.active {
					color: #DE0515;
				}

				li.active:before {
					background: #DE0515;
				}
			}

			.source-r {
				flex: 1;

				.type-cnt {
					display: flex;
					flex-wrap: wrap;
					justify-content: space-between;

					li {
						width: 31%;
						margin-bottom: 40px;

						.type-list {
							padding: 35px 40px;
							background-color: #f8f8f8;
							border-radius: 10px;
							border: 1px solid #f8f8f8;
							position: relative;
							padding-bottom: 40px;

							p {
								padding-bottom: 13px;
								font-size: 16px;
								line-height: 1.95;
							}
						}
					}

					li:hover {
						.type-list {
							border: 1px solid #ddd;
							cursor: pointer;
							border-radius: 10px;
						}
					}
				}
			}
		}
	}
	.h2-title-wrap {
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
		width: 1140px;
		margin: 0 auto;

		.h2-title {
			width: 31%;
			font-size: 34px;

			span {
				position: relative;
				display: inline-block;
				margin-bottom: 15px;
			}

			span:after {
				content: '';
				height: 2px;
				position: absolute;
				left: 0;
				background-color: #DE0515;
				width: 50%;
				display: inline-block;
				bottom: -14px;
			}
		}

		.description {
			width: 61%;
			margin-bottom: 25px;
			font-size: 16px;
			line-height: 1.889;
			color: #666;
		}
	}
	.link {
		display: flex;
		align-items: center;
		color: #DE0515;

		.text {
			line-height: 1.625;
		}

		.el-icon-right {
			font-size: 22px;
		}
	}
</style>
